import axiosIns from "@/api/axios";
// import axiosIns from "../dummy";

export const GET_ALL_IDEATION_API = (args) => {
  return axiosIns.get(`/ideation?${args}`);
};
export const GET_ALL_MODULE_API = (args) => {
  return axiosIns.get(`/module?${args}`);
};
export const GET_DETAIL_MODULE = (id) => {
  return axiosIns.get(`/module/${id}`);
};

export const SAVE_IDEATION = (args) => {
  return axiosIns.post(`/ideation`, args);
};

export const SAVE_DRAFT_IDEATION = (args) => {
  return axiosIns.put(`/ideation/${args.id}`, args.payload);
};

export const DELETE_IDEATION = (id) => {
  return axiosIns.delete(`/ideation/${id}`);
};

export const GET_ALL_IDEATION_DETAILS = (args) => {
  return axiosIns.get(`/ideation/${args.id}`);
};

export const GET_ALL_IDEATION_FLOW = (args) => {
  return axiosIns.get(`/ideation/${args.id}/flow`);
};

// GENTA GENDIS Action
export const VERIFIED_BY_GENTA_GENDIS = (args) => {
  return axiosIns.post(`/ideation/${args.id}/gg/validate`, args.notes);
};

export const VERIFIED_BY_GENTA_GENDIS_DRAFT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/gg/draft`, args.notes);
};

export const GET_NOTES_GENTA_GENDIS_DRAFT = (args) => {
  return axiosIns.get(`/ideation/${args}/gg/draft`);
};

export const REVISION_BY_GENTA_GENDIS = (args) => {
  return axiosIns.post(`/ideation/${args.id}/gg/revision`, args.notes);
};

// Demand Touchpoint Action
export const VERIFIED_DEMAND_TOUCHPOINT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/dtp/validate`, {
    final_requirement_document: args.bodys,
  });
};
export const REVISION_DEMAND_TOUCHPOINT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/dtp/revision`, args.notes);
};

export const VERIFIED_BY_DEMAND_TOUCHPOINT_DRAFT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/dtp/draft`, {
    final_requirement_document: args.bodys,
  });
};

export const GET_NOTES_DEMAND_TOUCHPOINT_DRAFT = (args) => {
  return axiosIns.get(`/ideation/${args}/dtp/draft`);
};

export const SEND_ACKNOWLEDGE_DEMANDTOUCHPOINT = (args) => {
  return axiosIns.post(`/ideation/demand_touchpoint/send_acknowledge`, args);
};

// SPG Action
export const VERIFIED_BY_SPG = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/validate`, args.body);
};
export const VERIFIED_BY_SPG_DRAFT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/draft`, args.body);
};
export const GET_SPG_DRAFT = (args) => {
  return axiosIns.get(`/ideation/${args}/spg/draft`);
};
export const REJECT_BY_SPG = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/reject`, args.notes);
};
export const REVISION_BY_SPG = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/revision`, args.notes);
};
export const HOLD_BY_SPG = (args) => {
  return axiosIns.post(
    `/ideation/${args.id}/spg/${args.status == "Hold" ? "hold" : "unhold"}`,
    args.notes
  );
};
export const FINALIZATION_SPG = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/finalization`, {
    requirement_boarding_spg: args.bodys,
  });
};
export const KICKOFF_BY_SPG = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/kickoff`, args.notes);
};
export const REVISION_KICKOFF = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/kickoff/revision`, args.notes);
};

export const FINALIZATION_BY_SPG_DRAFT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/finalization/draft`, {
    requirement_boarding_spg: args.bodys,
  });
};
export const GET_SPG_FINALIZATION_DRAFT = (args) => {
  return axiosIns.get(`/ideation/${args}/spg/finalization/draft`);
};
export const REVISION_FINALIZATION = (args) => {
  return axiosIns.post(
    `/ideation/${args.id}/spg/finalization/revision`,
    args.notes
  );
};
export const KICKOFF_BY_SPG_DRAFT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/spg/kickoff/draft`, args.notes);
};
export const GET_SPG_KICKOFF_DRAFT = (args) => {
  return axiosIns.get(`/ideation/${args}/spg/kickoff/draft`);
};

// Demand Solution Action
export const VERIFIED_DEMAND_SOLUTION = (args) => {
  return axiosIns.post(`/ideation/${args.id}/ds/validate`, {
    high_level_spesification: args.bodys,
  });
};
export const VERIFIED_BY_DEMAND_SOLUTION_DRAFT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/ds/draft`, {
    high_level_spesification: args.bodys,
  });
};

export const GET_DRAFT_DEMAND_SOLUTION = (args) => {
  return axiosIns.get(`/ideation/${args}/ds/draft`);
};

export const REVISION_DEMAND_SOLUTION = (args) => {
  return axiosIns.post(`/ideation/${args.id}/ds/revision`, args.notes);
};

// DIFO Action
export const VERIFIED_DIFO = (args) => {
  return axiosIns.post(`/ideation/${args.id}/difo/validate`, {
    technical_spesification_design: args.bodys,
  });
};
export const VERIFIED_DIFO_DRAFT = (args) => {
  return axiosIns.post(`/ideation/${args.id}/difo/draft`, {
    technical_spesification_design: args.bodys,
  });
};
export const REVISION_DIFO = (args) => {
  return axiosIns.post(`/ideation/${args.id}/difo/revision`, args.notes);
};

export const GET_DRAFT_DIFO = (args) => {
  return axiosIns.get(`/ideation/${args}/difo/draft`);
};

export const SUBMIT_PROJECT_DEVELOPMENT = (args) => {
  return axiosIns.post(
    `/ideation/${args.id}/difo/project-development/${args.type}`,
    args.body
  );
};

// PRA GO LIVE ACTIION
export const PRA_GOLIVE_SPG = (args) => {
  return axiosIns.post(
    `/ideation/${args.id}/spg/pra-go-live/${args.module_id}`,
    {
      pra_go_live: args.pra_go_live,
    }
  );
};

// GO LIVE ACTIION
export const GOLIVE_SPG = (args) => {
  return axiosIns.post(
    `/ideation/${args.id}/spg/go-live/${args.module_id}`,
    args.notes
  );
};

// Monitoring
export const MONITORING = (args) => {
  return axiosIns.post(
    `/ideation/${args.id}/dtp/monitoring/${args.module_id}`,
    {
      adoption_rate: args.body,
    }
  );
};

// Dashboard
export const GET_SUMMARY_DATA = () => {
  return axiosIns.get(`/dashboard/data`);
};
